<div class="home">
  <div class="game-rows">
    <div *ngFor="let row of gameRows" [ngClass]="['game-row', getRowClass(row.type)]">
      <app-game-card-alpha
        *ngFor="let game of row.items"
        class="game-card-item"
        [data]="game">
      </app-game-card-alpha>
    </div>
  </div>
</div>
